import { RequestStatus } from '@opengov/app-core/transport';
import { composeInitialState } from '@opengov/compose-app';
import { EmptyListOf, IRecordOf } from '@opengov/compose-app/immutable';
import { List } from 'immutable';

import { composeStateMachine } from '../../module';
import { CurrentOrLegacySavedView } from '../records/currentOrLegacySavedView';
import { ICurrentOrLegacySavedView } from '@opengov/reporting-legacy-module';

export const CurrentOrLegacySavedViewInitialState = composeInitialState({
  savedViews: EmptyListOf(CurrentOrLegacySavedView),
  loadingSavedViews: RequestStatus()
});

export const currentOrLegacySavedViewState = composeStateMachine(
  'common-saved-views',
  CurrentOrLegacySavedViewInitialState,
  (compose) => ({
    loadSavedViews: compose.payloadlessAction((state) =>
      state.set('loadingSavedViews', RequestStatus({ active: true }))
    ),

    loadSavedViewsSuccess: compose.action((state, payload: IRecordOf<ICurrentOrLegacySavedView>[]) =>
      state.set('loadingSavedViews', RequestStatus()).set('savedViews', List(payload))
    ),

    loadSavedViewsError: compose.action((state, error: any) => state.set('loadingSavedViews', RequestStatus({ error })))
  })
);

export const {
  actions: currentOrLegacySavedViewActions,
  actionCreators: currentOrLegacySavedViewActionCreators,
  reducer: currentOrLegacySavedViewReducer,
  selector: currentOrLegacySavedViewSelector
} = currentOrLegacySavedViewState;
